import { ApiHelper } from 'utils/apiHelper';

import { Environment } from 'Environment';
import * as ProjectTypes from 'reactApp/modules/ProjectModule/ProjectModule.types';

const BASE_URL = 'projects';

export const ProjectApi = {
    async loadData(pid: string) {
        return ApiHelper.rpcCall<ProjectTypes.ProjectData>({
            url: `${BASE_URL}/${pid}`,
        });
    },

    createProject: async (data?: { title?: string }) =>
        ApiHelper.rpcCall<{ project: ProjectTypes.ProjectData }>({
            method: 'POST',
            url: 'user/add/project',
            data: {
                ...data,
                metrics: Environment.utmParams,
            },
        }).then((res) => res.project),

    editData: async (pid: string, data: ProjectTypes.ProjectEditableData) =>
        ApiHelper.rpcCall({
            method: 'POST',
            url: `${BASE_URL}/${pid}`,
            data,
        }),

    enableTfa: async (pid: string) =>
        ApiHelper.rpcCall({
            method: 'PUT',
            url: `${BASE_URL}/${pid}/tfa`,
        }),

    disableTfa: async (pid: string) =>
        ApiHelper.rpcCall({
            method: 'DELETE',
            url: `${BASE_URL}/${pid}/tfa`,
        }),

    enableDebitNotif: async (pid: string, limit: number) =>
        ApiHelper.rpcCall<ProjectTypes.ProjectData>({
            method: 'POST',
            url: `${BASE_URL}/${pid}/notifications/debit`,
            data: {
                limit2notify: limit,
            },
        }),

    disableDebitNotif: async (pid: string) =>
        ApiHelper.rpcCall<ProjectTypes.ProjectData>({
            method: 'DELETE',
            url: `${BASE_URL}/${pid}/notifications/debit`,
        }),

    createPartnerProject: async (
        data: ProjectTypes.PartnerProjectCreatingParams,
    ) => {
        return ApiHelper.rpcCall<ProjectTypes.ProjectData>({
            method: 'POST',
            data,
            clearEmptyValues: true,
            url: `${BASE_URL}/partner`,
        });
    },

    fraudCheck: (pid: string) =>
        ApiHelper.rpcCall({
            method: 'POST',
            url: `${BASE_URL}/${pid}/verification/fraud`,
        }),
};
